'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ./~/intl-messageformat-parser/index.js
// module id = 381
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 15 16